/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * EasySplitDetails
 *
 */

import React, { memo, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import { Space, Text, Icon, Button, Conditional, AlertModal, ConfirmModal, Alert, Cross, Grid, Row, Column, Popup } from '@cashfree-intl/coherent';
import Loader from 'components/Loader';
import {
  getItemFromLocalStorage,
  copyToClipboard,
  previewFile,
  titleCase,
} from 'utils/common';
import {
  COUNTRY_CODE_OPTIONS,
  SETTLE_NOW,
  TX_STATUS_CLASSNAME,
  VENDOR_ONBOARDING_V2_BLACKLIST,
} from 'utils/constants';
import CustomIcon from 'components/CustomIcons';
import { MerchantContext } from 'contexts/MerchantContext';
import { Action } from 'styles';
import makeSelectEasySplitDetails from './selectors';
import reducer from './reducer';
import saga from './saga';
import {
  adjustBalanceAction,
  getKycDocsAction,
  getVendorDataByIdAction,
  getVendorKycDetailsAction,
  downloadDocAction,
  updateVendorAction,
  uploadKycDataAction,
  getVendorOdBalanceAction,
  initiateVendorOdAction,
  resetReducerStatesAction,
  getSettlementConfigAction,
  enableLoaderAction,
  disableLoaderAction,
  getDocsByUserAction,
  uploadVendorDocsAction,
  verifyPanAction,
  verifyGstAction,
  verifyCinAction,
} from './actions';
import {
  BLOCK,
  BLOCKED,
  BLOCKED_BANNER_INFO,
  BLOCK_CONFIRMATION_MODAL,
  BLOCK_CONFIRMATION_MODAL_INFO,
  CRITICAL_VENDOR_EDIT_SUCCESS,
  CRITICAL_VENDOR_EDIT_SUCCESS_INFO,
  DELETE,
  DELETED,
  DELETE_BANK_DETAILS,
  DELETE_CONFIRMATION_MODAL,
  DOCTYPE_NAME_MAPPING,
  EDIT_VENDOR,
  KYC_DOCS,
  NON_CRITICAL_VENDOR_EDIT_SUCCESS,
  ON_HOLD,
  ON_HOLD_BANNER_INFO,
  POSSIBLE_DOCS,
  UNBLOCK_CONFIRMATION_MODAL,
  UNBLOCK_CONFIRMATION_MODAL_INFO,
  VENDOR_ADDED_FAILED,
  VENDOR_ADDED_FAILED_INFO,
  BANK_VALIDATION_FAILED,
} from './constants';
import { ADJUST_BALANCE } from '../Adjustments/constants';
import {
  IN_BENE_CREATION,
  IN_KYC_REVIEW,
  KYC_PENDING,
  MINIMUM_VENDOR_BALANCE,
  SETTLE_NOW_STATUS_MAPPER,
  VENDOR_STATUS,
} from '../Vendors/constants';
import AdjustBalanceModal from '../Adjustments/components/AdjustBalanceModal';
import EasySplitModalV2 from '../Vendors/components/EasySplitModalV2';
import EasySplitSettleNow from '../Vendors/components/EasySplitSettleNow';
import {
  StyledBackText,
  StyledCopyToClipboard,
  StyledPaper,
  StyledStatusText,
} from './styled';
import VendorAccountDetails from './components/VendorAccountDetails';
import VendorBankDetails from './components/VendorBankDetails';
import VendorSettlementDetails from './components/VendorSettlementDetails';
import VendorKycDetails from './components/VendorKycDetails';
import ManageVendorDropdown from './components/ManageVendorDropdown';
import VendorKycDetailsV2 from './components/VendorKycDetailsV2';

export function EasySplitDetails({
  easySplitDetails,
  getVendorDataById,
  getVendorKycDetails,
  getKycDocs,
  adjustBalance,
  downloadDoc,
  updateVendor,
  uploadKycData,
  getVendorOdBalance,
  initiateVendorOd,
  resetReducerStates,
  getSettlementConfig,
  enableLoader,
  disableLoader,
  getDocsByUser,
  uploadVendorDocs,
  verifyPan,
  verifyCin,
  verifyGst,
}) {
  useInjectReducer({ key: 'easySplitDetails', reducer });
  useInjectSaga({ key: 'easySplitDetails', saga });

  const location = useLocation();

  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);

  const vendorId = searchParams.get('merchantVendorId');

  const criticalMerchant = JSON.parse(searchParams.get('isCritical'));

  const vendorOdEnabled = searchParams.get('vendorOd');

  const merchantId = getItemFromLocalStorage('merchantId');

  const [openModalName, resetModalDisplay] = useState('');
  const [modalData, resetModalData] = useState({});
  const [editVendorFormStep, setEditVendorFormStep] = useState(1);
  const [modalErr, resetModalErr] = useState('');
  const [vendorDeleted, setVendorDeleted] = useState(false);
  const [showBanner, setShowBanner] = useState(true);
  const [KYC_DOCUMENTS, setKycDocs] = useState(KYC_DOCS);
  const [filePreviewMapping, setFilePreviewMapping] = useState({});
  const [nbfc, setNbfc] = useState();
  const [userInfo, setUserInfo] = useState({});

  const {
    SETTLEMENT_DETAILS,
    BANK_DETAILS,
    KYC_DETAILS,
    ACCOUNT_DETAILS,
    vendorIdData,
    kycResponse,
    vendorStatus,
    vendorDetailsSuccessResponse,
    kycDetialsSuccessResponse,
    kycDocsSuccessResponse,
    schedules,
    isLoading,
    vendorDocs,
    vendorAccountInfo,
  } = easySplitDetails;

  const { ...merchantContextData } = useContext(MerchantContext);

  const { featureToggles = {} } = merchantContextData;

  const incrementalVendorOnboarding =
    !!featureToggles &&
    VENDOR_ONBOARDING_V2_BLACKLIST in featureToggles &&
    !featureToggles?.[VENDOR_ONBOARDING_V2_BLACKLIST];

  useEffect(() => {
    getVendorDataById({
      vendorId,
      cb: response => {
        if (response.status === DELETED) setVendorDeleted(true);
      },
    });
    if (!incrementalVendorOnboarding) {
      getVendorKycDetails({ updatedBy: merchantId, vendorId });
      getKycDocs({ vendorId });
    }
    getSettlementConfig();
  }, []);

  const closeModal = () => {
    getVendorDataById({ vendorId });
    if (!incrementalVendorOnboarding) {
      if (!vendorDeleted)
        getVendorKycDetails({ updatedBy: merchantId, vendorId });
      getKycDocs({ vendorId });
    }
    resetModalData({});
    resetModalDisplay('');
    resetModalErr('');
  };

  useEffect(() => {
    const { accountType, businessType, name } = vendorAccountInfo;
    setUserInfo({
      userAccountType: accountType,
      userBusinessType: businessType,
      userName: vendorId,
      name,
    });
    // check if vendor is also onboarded on new flow
    if (businessType && incrementalVendorOnboarding) {
      getDocsByUser({
        vendorId,
        accountType,
        businessType,
        cb: () => {
          if (openModalName) {
            closeModal();
          }
        },
      });
    }
  }, [vendorAccountInfo]);

  const navigateBack = () => {
    resetReducerStates();
    navigate(-1);
  };

  // eslint-disable-next-line no-unused-vars
  const handleEasySplitVendorClick = ({ modalName, rowData }) => e => {
    // if (e) e.stopPropagation();
    resetModalData(rowData);
    resetModalDisplay(modalName);
  };

  const onAdjustBalanceSubmit = (payload, actions) => {
    adjustBalance({
      data: payload,
      successCb: () => {
        closeModal();
      },
      errorCb: () => actions.setSubmitting(false),
    });
  };

  const handleDeleteVendorClick = () => {
    resetModalDisplay(DELETE_CONFIRMATION_MODAL);
  };

  const handleBlockVendorClick = () => {
    resetModalDisplay(BLOCK_CONFIRMATION_MODAL);
  };

  const handleUnblockVendorClick = () => {
    resetModalDisplay(UNBLOCK_CONFIRMATION_MODAL);
  };

  const onManageVendorClick = event => {
    switch (event.value) {
      case BLOCK:
        // eslint-disable-next-line no-unused-expressions
        vendorIdData.status === BLOCKED
          ? handleUnblockVendorClick()
          : handleBlockVendorClick();
        break;
      case DELETE:
        handleDeleteVendorClick();
        break;
      default:
        break;
    }
  };

  const onFilePreviewClickHandler = docType => {
    enableLoader();
    downloadDoc({
      data: { merchantVendorId: vendorId, docType },
      cb: response => {
        disableLoader();
        const { downloadUrl } = response;
        previewFile(downloadUrl);
      },
    });
  };

  const handleEditVendorFormStep = detailType => {
    switch (detailType) {
      case 'accountDetails':
        setEditVendorFormStep(1);
        break;
      case 'bankDetails':
        setEditVendorFormStep(2);
        break;
      case 'kycDetails':
        setEditVendorFormStep(3);
        break;
      default:
        break;
    }
  };

  const onEditClickHandler = detailType => {
    handleEditVendorFormStep(detailType);
    resetModalDisplay(EDIT_VENDOR);
    if (vendorIdData) {
      let phoneNumber = vendorIdData.phone;
      let numberInitial = '+91';
      if (phoneNumber && phoneNumber.length) {
        if (
          COUNTRY_CODE_OPTIONS.findIndex(
            obj => obj.text === phoneNumber.slice(0, 2),
          ) !== -1
        ) {
          numberInitial = phoneNumber.slice(0, 2);
          phoneNumber = phoneNumber.slice(2);
        } else if (
          COUNTRY_CODE_OPTIONS.findIndex(
            obj => obj.text === phoneNumber.slice(0, 3),
          ) !== -1
        ) {
          numberInitial = phoneNumber.slice(0, 3);
          if (phoneNumber.startsWith('+91-')) {
            phoneNumber = phoneNumber.slice(4);
          } else {
            phoneNumber = phoneNumber.slice(3);
          }
        } else if (phoneNumber.startsWith('0')) {
          phoneNumber = phoneNumber.slice(1);
        }
      }
      resetModalData({
        ...vendorIdData,
        phone: phoneNumber,
        numberInitial,
        scheduleOption:
          vendorIdData.schedule && vendorIdData.schedule.scheduleId.toString(),
        vendorId: vendorIdData.merchantVendorId,
      });
    }
  };

  const businessInfo = {
    accountType: KYC_DETAILS.accountType,
    businessType: KYC_DETAILS.businessType,
  };

  let vendorDetailsPayload = {};

  const handleVendorDetailsPayload = (payload, actions) => {
    vendorDetailsPayload = {
      ...modalData,
      ...vendorDetailsPayload,
      ...payload,
    };
    if (!payload?.accountType && !payload?.businessType) {
      delete vendorDetailsPayload.accountType;
      delete vendorDetailsPayload.businessType;
    }
    if (!payload?.name) {
      DELETE_BANK_DETAILS.forEach(property => {
        if (!payload?.[property]) {
          delete vendorDetailsPayload?.[property];
        }
      });
    }
    triggerVendorDataApi(vendorDetailsPayload, actions, criticalMerchant);
  };

  const submitKycModal = (fileObj, isCritical, actions, merchantVendorId) => {
    enableLoader();
    const updatedPayload = {
      data: fileObj,
      updatedBy: getItemFromLocalStorage('merchantId'),
      merchantVendorId,
      cb: () => {
        disableLoader();
        actions.setSubmitting(false);
        if (isCritical) {
          resetModalDisplay(CRITICAL_VENDOR_EDIT_SUCCESS);
        } else {
          resetModalDisplay(NON_CRITICAL_VENDOR_EDIT_SUCCESS);
        }
      },
      errCb: () => {
        resetModalDisplay(VENDOR_ADDED_FAILED);
      },
      actions,
    };
    uploadKycData(updatedPayload);
  };

  const triggerVendorDataApi = (payload, actions, isCritical) => {
    enableLoader();
    let showVendorDbToggle;
    if ('dashboardAccess' in payload) {
      showVendorDbToggle = true;
    }
    const fileObj = payload.completeFileObj;
    // eslint-disable-next-line no-param-reassign
    delete payload.completeFileObj;
    const updatedPayload = {
      data: {
        ...payload,
        updatedBy: getItemFromLocalStorage('merchantId'),
        vendorStatus,
      },
      cb: () => {
        disableLoader();
        actions.setSubmitting(false);
        submitKycModal(fileObj, isCritical, actions, payload.vendorId);
        closeModal();
      },
      errorCb: err => {
        resetModalErr(err);
      },
      actions,
      showVendorDbToggle,
    };
    updateVendor(updatedPayload);
  };

  const handleKycDataPayload = (payload, actions, isCritical) => {
    vendorDetailsPayload = {
      ...modalData,
      ...vendorDetailsPayload,
      ...payload,
    };
    triggerVendorDataApi(vendorDetailsPayload, actions, isCritical);
  };

  const passVendorDetails = payload => {
    vendorDetailsPayload = {
      ...modalData,
      ...payload,
    };
  };

  const submitDeleteVendorModal = () => {
    enableLoader();
    updateVendor({
      data: {
        ...vendorIdData,
        status: VENDOR_STATUS.DELETED,
        updatedBy: merchantId,
      },
      cb: () => {
        setVendorDeleted(true);
        closeModal();
        disableLoader();
      },
      errorCb: () => {
        closeModal();
      },
      statusChange: true,
    });
  };

  const isLoaderActive = () => {
    let isActive = !vendorDetailsSuccessResponse;
    if (!incrementalVendorOnboarding) {
      isActive = isActive || !kycDocsSuccessResponse;
      if (vendorStatus !== DELETED) {
        isActive = isActive || !kycDetialsSuccessResponse;
      }
    }
    return isActive;
  };

  const lowBalance = +vendorIdData?.balance < MINIMUM_VENDOR_BALANCE;
  const enableSettleNow =
    vendorOdEnabled &&
    !lowBalance &&
    vendorIdData?.status === VENDOR_STATUS.ACTIVE;

  const handleSettleNowBtnCLick = () => {
    const { nextSettlementDate } = vendorIdData;
    resetModalData({ merchantVendorId: vendorId, nextSettlementDate });
    resetModalDisplay(SETTLE_NOW);
  };

  const closeEasySplitSettleNow = () => {
    resetModalDisplay('');
    resetModalData({});
  };

  const settleNowStatusObj = SETTLE_NOW_STATUS_MAPPER[openModalName];

  const submitBlockVendorModal = () => {
    enableLoader();
    updateVendor({
      data: {
        ...vendorIdData,
        status: VENDOR_STATUS.ACTIVE
          ? VENDOR_STATUS.BLOCKED
          : VENDOR_STATUS.ACTIVE,
        vendorStatus: VENDOR_STATUS.BLOCKED
          ? IN_BENE_CREATION
          : vendorIdData.status,
        updatedBy: merchantId,
      },
      cb: () => {
        getVendorDataById({
          vendorId,
          cb: () => {
            disableLoader();
          },
        });
        closeModal();
      },
      errorCb: () => {},
      statusChange: true,
    });
  };

  const submitUnblockVendorModal = () => {
    enableLoader();
    updateVendor({
      data: {
        ...vendorIdData,
        status: VENDOR_STATUS.ACTIVE,
        vendorStatus: VENDOR_STATUS.BLOCKED
          ? IN_BENE_CREATION
          : vendorIdData.status,
        updatedBy: merchantId,
      },
      cb: () => {
        getVendorDataById({
          vendorId,
          cb: () => {
            disableLoader();
          },
        });
        closeModal();
      },
      errorCb: () => {},
      statusChange: true,
    });
  };

  useEffect(() => {
    const docs = { ...KYC_DOCS };
    if (kycResponse && kycResponse.documents)
      kycResponse.documents.forEach(obj => {
        if (obj.docType === 'NBFC_CERTIFICATE') {
          setNbfc(obj);
          filePreviewMapping[obj.docValue] = obj.docType;
        }
        if (POSSIBLE_DOCS.includes(obj.docType)) {
          docs[DOCTYPE_NAME_MAPPING[obj.docType]] = [
            ...docs[DOCTYPE_NAME_MAPPING[obj.docType]],
            obj.docValue,
          ];
          filePreviewMapping[obj.docValue] = obj.docType;
        }
      });
    setKycDocs(docs);
    setFilePreviewMapping(filePreviewMapping);
  }, [kycResponse]);

  const submitVendorDocuments = (payload, docNameTypeMapping, actions) => {
    const { userName, userAccountType, userBusinessType } = userInfo;
    uploadVendorDocs({
      userName,
      userAccountType,
      userBusinessType,
      payload,
      docNameTypeMapping,
      updatedBy: +getItemFromLocalStorage('merchantId'),
      cb: () => {
        closeModal();
      },
      actions,
    });
  };

  const saveAndExitKycForm = (payload, docNameTypeMapping) => {
    if (Object.keys(userInfo).length) {
      const { userName, userAccountType, userBusinessType } = userInfo;
      uploadVendorDocs({
        userName,
        userAccountType,
        userBusinessType,
        payload,
        docNameTypeMapping,
        updatedBy: merchantId,
        cb: () => {
          resetModalDisplay(KYC_PENDING);
        },
      });
    }
  };

  return (
    <div>
      <Conditional if={isLoaderActive() || isLoading}>
        <Loader active />
      </Conditional>
      {!!settleNowStatusObj && (
        <AlertModal
          type={settleNowStatusObj.type}
          title={settleNowStatusObj.title}
          onClose={closeModal}
          eventNameOnClose={`${settleNowStatusObj.title
            .split(' ')
            .join('_')}_Close`}
        >
          <p className="text-light">{settleNowStatusObj.description}</p>
          <Grid
            className={`alert-modal content-wrapper ${settleNowStatusObj.type}`}
          >
            {Object.keys(settleNowStatusObj.content).map(key => (
              <Row columns={2} key={key}>
                <Column>
                  <span className="text-light">
                    {settleNowStatusObj.content[key]}
                  </span>
                </Column>
                <Column>
                  <span className="text-dark w-600">{modalData[key]}</span>
                </Column>
              </Row>
            ))}
          </Grid>
        </AlertModal>
      )}
      <Conditional if={openModalName === VENDOR_ADDED_FAILED}>
        <AlertModal
          type="danger"
          title="Vendor Details Not Added"
          onClose={closeModal}
          eventNameOnClose="Vendor_Details_Not_Added_Close"
        >
          <p>{VENDOR_ADDED_FAILED_INFO}</p>
        </AlertModal>
      </Conditional>
      <Conditional if={openModalName === SETTLE_NOW}>
        <EasySplitSettleNow
          open
          closeModal={closeEasySplitSettleNow}
          data={modalData}
          resetModalData={resetModalData}
          resetModalDisplay={resetModalDisplay}
          getVendorOdBalance={getVendorOdBalance}
          initiateVendorOd={initiateVendorOd}
        />
      </Conditional>
      <Conditional if={openModalName === DELETE_CONFIRMATION_MODAL}>
        <ConfirmModal
          danger
          title="Delete Vendor"
          onClose={closeModal}
          onConfirm={submitDeleteVendorModal}
          confirmText="Delete"
          confirmBtnEvent="Danger_Button_Delete_Vendor_Confirm"
          closeBtnEvent="Link_Button_Delete_Vendor_Cancel"
          closeCrossEvent="Delete_Vendor_Icon_Close"
        >
          Payments or settlements cannot be made to {vendorId} after you delete.
          Are you sure you want to delete it?
        </ConfirmModal>
      </Conditional>
      <Conditional if={openModalName === BLOCK_CONFIRMATION_MODAL}>
        <ConfirmModal
          danger
          title="Block Vendor"
          onClose={closeModal}
          onConfirm={submitBlockVendorModal}
          confirmText="Block Vendor"
          confirmBtnEvent="Danger_Button_Block_Vendor_Confirm"
          closeBtnEvent="Link_Button_Block_Vendor_Cancel"
          closeCrossEvent="Block_Vendor_Icon_Close"
        >
          {BLOCK_CONFIRMATION_MODAL_INFO}
        </ConfirmModal>
      </Conditional>
      <Conditional if={openModalName === UNBLOCK_CONFIRMATION_MODAL}>
        <ConfirmModal
          danger
          title="Unblock Vendor"
          onClose={closeModal}
          onConfirm={submitUnblockVendorModal}
          confirmText="Unblock Vendor"
          confirmBtnEvent="Danger_Button_Unblock_Vendor_Confirm"
          closeBtnEvent="Link_Button_Unblock_Vendor_Cancel"
          closeCrossEvent="Unblock_Vendor_Icon_Close"
        >
          {UNBLOCK_CONFIRMATION_MODAL_INFO}
        </ConfirmModal>
      </Conditional>
      <Conditional if={openModalName === CRITICAL_VENDOR_EDIT_SUCCESS}>
        <AlertModal
          type="success"
          title="Vendor Details Updated Successfully"
          onClose={closeModal}
          eventNameOnClose="Vendor_Details_Updated_Successfully_Close"
        >
          <p>{CRITICAL_VENDOR_EDIT_SUCCESS_INFO}</p>
        </AlertModal>
      </Conditional>
      <Conditional if={openModalName === NON_CRITICAL_VENDOR_EDIT_SUCCESS}>
        <AlertModal
          type="success"
          title="Vendor Details Updated Successfully"
          onClose={closeModal}
          eventNameOnClose="Vendor_Details_Updated_Successfully_Close"
        />
      </Conditional>
      <Conditional if={openModalName === ADJUST_BALANCE}>
        <AdjustBalanceModal
          onClose={closeModal}
          onSubmit={onAdjustBalanceSubmit}
          vendorDataById={getVendorDataById}
        />
      </Conditional>
      <Conditional if={openModalName === KYC_PENDING}>
        <AlertModal
          type="success"
          title="KYC Pending"
          onClose={closeModal}
          eventNameOnClose="KYC_Pending_Close"
        >
          <p>
            Your progress is saved. To finish your pending KYC, click
            &quot;Complete Activation&apos; on the dashboard.
          </p>
        </AlertModal>
      </Conditional>
      <Conditional if={openModalName === EDIT_VENDOR}>
        <EasySplitModalV2
          open={[EDIT_VENDOR].includes(openModalName)}
          isEditMode
          closeModal={closeModal}
          data={modalData}
          modalErr={modalErr}
          scheduleOptions={schedules}
          editModalLoading={false}
          handleVendorDetailsPayload={handleVendorDetailsPayload}
          handleKycDataPayload={handleKycDataPayload}
          downloadDoc={downloadDoc}
          vendorId={vendorId}
          kycData={kycResponse}
          businessRelatedInfo={businessInfo}
          isMerchantCritical={criticalMerchant}
          vendorStatus={modalData.status}
          detailsPageStep={editVendorFormStep}
          detailsPageClicked
          passVendorDetails={passVendorDetails}
          incrementalVendorOnboarding={incrementalVendorOnboarding}
          vendorDocs={vendorDocs}
          submitVendorDocuments={submitVendorDocuments}
          verifyPan={verifyPan}
          verifyCin={verifyCin}
          verifyGst={verifyGst}
          saveAndExitKycForm={saveAndExitKycForm}
          userInfo={userInfo}
        />
      </Conditional>
      <Conditional
        if={vendorIdData?.status === BANK_VALIDATION_FAILED && showBanner}
      >
        <Alert className="mb-2" size="md" type="danger" compact bordered>
          Bank Account Verification failed for this vendor.{' '}
          {vendorIdData?.remarks}
          <Button
            primary
            size="small"
            className="ml-2"
            onClick={() => {
              setShowBanner(false);
              onEditClickHandler('bankDetails');
            }}
            data-event-name="Primary_Button_Edit"
          >
            Update Bank Details
          </Button>
        </Alert>
      </Conditional>
      <Conditional if={vendorIdData?.status === BLOCKED && showBanner}>
        <Alert className="mb-2" size="md" type="warning" compact bordered>
          {BLOCKED_BANNER_INFO}
          <Cross
            size="md"
            className="ml-3"
            onClick={() => setShowBanner(false)}
            data-event-name="Form_EasySplitDetails_Icon_Close"
            data-ignore-inner-text="true"
          />
        </Alert>
      </Conditional>
      <Conditional if={vendorIdData?.status === ON_HOLD && showBanner}>
        <Alert className="mb-2" size="md" type="warning" compact bordered>
          {ON_HOLD_BANNER_INFO}
          <Button
            primary
            size="small"
            className="ml-2"
            onClick={() => onEditClickHandler('kycDetails')}
            data-event-name="Primary_Button_Edit"
          >
            Edit
          </Button>
          <Cross
            size="md"
            className="ml-3"
            onClick={() => setShowBanner(false)}
            data-event-name="Form_EasySplitDetails_Icon_Close"
            data-ignore-inner-text="true"
          />
        </Alert>
      </Conditional>
      <Space justifyContent="space-between">
        <div onClick={navigateBack} data-event-name="Button_Back">
          <Icon name="chevron-left" />
          <StyledBackText className="ml-1" variant="b14" color="primary" strong>
            Back
          </StyledBackText>
        </div>
        <Conditional if={!vendorDeleted}>
          <Space className="mb-2" gap={2}>
            <Button
              primary
              onClick={handleEasySplitVendorClick({
                modalName: ADJUST_BALANCE,
                rowData: {},
              })}
              data-event-name="Primary_Button_AdjustBalance"
            >
              Adjust Balance
            </Button>

            <ManageVendorDropdown
              vendorIdData={vendorIdData}
              onManageVendorClick={onManageVendorClick}
            />
          </Space>
        </Conditional>
      </Space>
      <StyledPaper>
        <Space direction="column">
          <Space justifyContent="space-between">
            <Text variant="b14" color="bodyLight">
              Vendor ID
            </Text>
            {vendorIdData && (
              <>
                <Conditional if={vendorIdData?.status === IN_KYC_REVIEW}>
                  <Popup
                    content={
                      <Space gap={1} direction="column">
                        <Text strong variant="b12">
                          In KYC Review
                        </Text>
                        <Text color="bodyLight" variabt="b12">
                          Vendor’s KYC is currently being reviewed. Vendor will
                          be activated post successful KYC
                        </Text>
                      </Space>
                    }
                    trigger={
                      <div className="pointer">
                        <StyledStatusText
                          status={vendorIdData?.status}
                          className={`w-600 ${TX_STATUS_CLASSNAME[
                            (vendorIdData?.status)
                          ] || ''}`}
                        >
                          {titleCase(IN_KYC_REVIEW)}
                        </StyledStatusText>
                      </div>
                    }
                    position="top center"
                  />
                </Conditional>
                <Conditional if={vendorIdData?.status !== IN_KYC_REVIEW}>
                  <StyledStatusText
                    status={vendorIdData?.status}
                    className={`w-600 ${TX_STATUS_CLASSNAME[
                      (vendorIdData?.status)
                    ] || ''}`}
                  >
                    {titleCase(vendorIdData?.status)}
                  </StyledStatusText>
                </Conditional>
              </>
            )}
          </Space>
          <Space gap={1} alignItems="center">
            <Text className="mt-1" variant="h16" strong>
              {vendorId}
            </Text>
            <StyledCopyToClipboard className="mt-1">
              <Action>
                <CustomIcon
                  componentName="COPY_TO_CLIPBOARD"
                  handleClick={copyToClipboard(vendorId)}
                />
              </Action>
            </StyledCopyToClipboard>
          </Space>
        </Space>
      </StyledPaper>
      <VendorSettlementDetails
        vendorIdData={vendorIdData}
        enableSettleNow={enableSettleNow}
        handleSettleNowBtnCLick={handleSettleNowBtnCLick}
        lowBalance={lowBalance}
        settlementDetailsObj={SETTLEMENT_DETAILS}
      />

      <VendorAccountDetails
        vendorDeleted={vendorDeleted}
        accountDetailsObj={ACCOUNT_DETAILS}
        vendorId={vendorId}
        onEditClickHandler={onEditClickHandler}
      />

      <VendorBankDetails
        vendorDeleted={vendorDeleted}
        bankDetailsObj={BANK_DETAILS}
        vendorId={vendorId}
        onEditClickHandler={onEditClickHandler}
      />

      <Conditional if={!incrementalVendorOnboarding}>
        <VendorKycDetails
          vendorDeleted={vendorDeleted}
          kycDetailsObj={KYC_DETAILS}
          kycDocumentsObj={KYC_DOCUMENTS}
          onEditClickHandler={onEditClickHandler}
          onFilePreviewClickHandler={onFilePreviewClickHandler}
          filePreviewMapping={filePreviewMapping}
          nbfc={nbfc}
        />
      </Conditional>

      <Conditional if={incrementalVendorOnboarding}>
        <VendorKycDetailsV2
          vendorDocs={vendorDocs}
          onFilePreviewClickHandler={onFilePreviewClickHandler}
          onEditClickHandler={onEditClickHandler}
        />
      </Conditional>
    </div>
  );
}

EasySplitDetails.propTypes = {
  easySplitDetails: PropTypes.object.isRequired,
  getVendorDataById: PropTypes.func.isRequired,
  getVendorKycDetails: PropTypes.func.isRequired,
  getKycDocs: PropTypes.func.isRequired,
  adjustBalance: PropTypes.func.isRequired,
  downloadDoc: PropTypes.func.isRequired,
  updateVendor: PropTypes.func.isRequired,
  uploadKycData: PropTypes.func.isRequired,
  getVendorOdBalance: PropTypes.func.isRequired,
  initiateVendorOd: PropTypes.func.isRequired,
  resetReducerStates: PropTypes.func.isRequired,
  getSettlementConfig: PropTypes.func.isRequired,
  enableLoader: PropTypes.func.isRequired,
  disableLoader: PropTypes.func.isRequired,
  getDocsByUser: PropTypes.func.isRequired,
  uploadVendorDocs: PropTypes.func,
  verifyPan: PropTypes.func,
  verifyCin: PropTypes.func,
  verifyGst: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  easySplitDetails: makeSelectEasySplitDetails(),
});

export function mapDispatchToProps(dispatch) {
  return {
    getVendorDataById: data => dispatch(getVendorDataByIdAction(data)),
    getVendorKycDetails: data => dispatch(getVendorKycDetailsAction(data)),
    getKycDocs: data => dispatch(getKycDocsAction(data)),
    adjustBalance: data => dispatch(adjustBalanceAction(data)),
    downloadDoc: data => dispatch(downloadDocAction(data)),
    updateVendor: data => dispatch(updateVendorAction(data)),
    uploadKycData: data => dispatch(uploadKycDataAction(data)),
    getVendorOdBalance: data => dispatch(getVendorOdBalanceAction(data)),
    initiateVendorOd: data => dispatch(initiateVendorOdAction(data)),
    resetReducerStates: data => dispatch(resetReducerStatesAction(data)),
    getSettlementConfig: data => dispatch(getSettlementConfigAction(data)),
    enableLoader: () => dispatch(enableLoaderAction()),
    disableLoader: () => dispatch(disableLoaderAction()),
    getDocsByUser: data => dispatch(getDocsByUserAction(data)),
    uploadVendorDocs: data => dispatch(uploadVendorDocsAction(data)),
    verifyPan: data => dispatch(verifyPanAction(data)),
    verifyGst: data => dispatch(verifyGstAction(data)),
    verifyCin: data => dispatch(verifyCinAction(data)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(EasySplitDetails);
